import type { KeyResultUnitValue } from '@/constants/KeyResultUnit';
import type { TranslationKey } from '@/i18n-key';

import { KeyResultUnit } from '@/constants/KeyResultUnit';

/** The label of each key result unit, wherever a unit is named to the reader. */
export const KEY_RESULT_UNIT_LABEL_KEYS: Record<KeyResultUnitValue, TranslationKey> = {
    [KeyResultUnit.NUMBER]: 'objectives.form.unit.number',
    [KeyResultUnit.PERCENTAGE]: 'objectives.form.unit.percentage',
    [KeyResultUnit.MONETARY]: 'objectives.form.unit.monetary',
    [KeyResultUnit.YES_NO]: 'objectives.form.unit.yesNo',
};

interface EmptyObjectiveListCause {
    /** Whether owners still held objectives before the state filter ran: then it is what emptied
     *  the list, whatever the other filters are doing. */
    hasObjectivesBeforeStatusFilter: boolean;
    isAttributeFilterActive: boolean;
    /** Whether the reader's reach is their team rather than the whole company: the people the
     *  filter missed are then said to be of that team. */
    isTeamReach: boolean;
}

/**
 * Names the filter that emptied the objectives list, so the reader knows what to undo: the state
 * filter narrows objectives, the attribute one narrows people. They stack, so only the last one to
 * run on a non-empty list is named.
 */
export const emptyListMessageKey = ({
    hasObjectivesBeforeStatusFilter,
    isAttributeFilterActive,
    isTeamReach,
}: EmptyObjectiveListCause): TranslationKey => {
    if (hasObjectivesBeforeStatusFilter) {
        return 'objectives.byOwner.noStatusResults';
    }

    if (isAttributeFilterActive) {
        return isTeamReach
            ? 'objectives.byOwner.noFilterResultsInTeam'
            : 'objectives.byOwner.noFilterResults';
    }

    return 'objectives.byOwner.noResults';
};
